<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: xjf
 * @LastEditTime: 2025-02-07 16:47:13
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>违规管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">违规列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="标题">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入标题"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="停用" value="0"></el-option>
                    <el-option label="启用" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="身份类型">
                  <el-select
                    v-model="ruleForm.type"
                    placeholder="请选择身份类型"
                    style="margin-right: auto"
                  >
                    <el-option label="所有" value="0"></el-option>
                    <el-option label="客户" value="1"></el-option>
                    <el-option label="保安" value="2"></el-option>
                    <el-option label="保安公司" value="4"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column label="身份类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.memberType == 0">所有用户</span>
              <span v-if="scope.row.memberType == 1">客户</span>
              <span v-if="scope.row.memberType == 2">保安</span>
              <!-- <span v-if="scope.row.memberType == 4">保安公司</span> -->
              <!-- <span v-if="scope.row.memberType == 3">临勤</span>
              <span v-if="scope.row.memberType == 5">保安公司员工</span> -->
            </template>
          </el-table-column>
          <el-table-column label="任务类型" align="center">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.jobStatus == 2"
                >发布中</span
              >
              <span class="blueColor" v-if="scope.row.jobStatus == 4"
                >实做中</span
              >
              <span class="greenColor" v-if="scope.row.jobStatus == 3"
                >已收单</span
              >
            </template>
          </el-table-column>
          <el-table-column label="违规规则" align="center" width="160">
            <template slot-scope="scope">
              <span v-if="scope.row.jobStatus == 2"
                >申请人：{{ scope.row.putInNum }}人</span
              >
              <div>
                <span class="decoration"
                  >申请时间：>={{ scope.row.putInAt }}分钟</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column label="违规描述" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.memo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="扣费" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.withholdType == 2"
                >￥{{ scope.row.withholdNum | moneyFormat }}</span
              >
              <span v-if="scope.row.withholdType == 1"
                >{{ scope.row.withholdNum }}%</span
              >
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.status == 0">停用</span>
              <span class="greenColor" v-if="scope.row.status == 1">启用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn greenColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  启用
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 1"
                >
                  停用
                </div>
                <div class="operateBtn" @click="edit(scope.row)">编辑</div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item label="用户类型" prop="type">
          <el-select v-model="ruleForm1.type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务状态" prop="type1">
          <el-select
            v-model="ruleForm1.type1"
            placeholder="请选择"
            @change="selectStatus"
          >
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请人数" prop="num" v-if="ruleForm1.type1 == 2">
          <el-input placeholder="请输入内容" v-model="ruleForm1.num">
            <template slot="append">人</template>
          </el-input>
        </el-form-item>
        <el-form-item label="申请时间" prop="time" v-if="ruleForm1.type1 == 2">
          <el-input placeholder="请输入内容" v-model="ruleForm1.time">
            <template slot="append">分钟</template>
          </el-input>
        </el-form-item>
        <el-form-item label="扣款方式" prop="deduction">
          <el-select v-model="ruleForm1.deduction" placeholder="请选择">
            <el-option
              v-for="item in moneyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="扣   款" prop="money" label-width="80px">
          <el-input
            placeholder="请输入扣款"
            v-model="ruleForm1.money"
            type="number"
          >
            <template slot="append" v-if="ruleForm1.deduction == 1"
              >.com</template
            >
          </el-input>
        </el-form-item>
        <el-form-item label="违约描述" prop="memo">
          <el-input
            type="textarea"
            v-model="ruleForm1.memo"
            placeholder="请输入违约描述"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        name: "",
        status: "",
        type: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      title: "新增违规",
      ruleForm1: {
        type: "",
        memo: "",
        money: "",
        time: "",
        num: "",
        deduction: "",
        type1: "",
      },
      rules: {
        type: [{ required: true, message: "必选项", trigger: "change" }],
        type1: [{ required: true, message: "必选项", trigger: "change" }],
        time: [{ required: true, message: "必选项", trigger: "change" }],
        num: [{ required: true, message: "必选项", trigger: "change" }],
        deduction: [{ required: true, message: "必选项", trigger: "change" }],
        memo: [{ required: true, message: "必填项", trigger: "blur" }],
        money: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      options: [
        { label: "所有用户", value: "0" },
        { label: "客户", value: "1" },
        { label: "保安", value: "2" },
        // { label: "临勤", value: "3" },
        // { label: "保安公司", value: "4" },
        // { label: "保安公司员工", value: "5" }
      ],
      options1: [
        { label: "发布中", value: "2" },
        { label: "实做中", value: "4" },
        { label: "已收单", value: "3" },
      ],
      editId: "",
      moneyList: [
        { label: "比例整数百分比", value: "1" },
        { label: "金额", value: "2" },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    selectStatus() {
      this.ruleForm1.num = "";
      this.ruleForm1.time = "";
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            memberType: this.ruleForm1.type,
            memo: this.ruleForm1.memo,
            putInAt: this.ruleForm1.time,
            putInNum: this.ruleForm1.num,
            withholdNum: this.ruleForm1.money,
            withholdType: this.ruleForm1.deduction,
            jobStatus: this.ruleForm1.type1,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/violaterule/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally((this.dialogFormVisible = false));
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/violaterule/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.editId = "";
                this.ruleForm1.type = "";
                this.ruleForm1.memo = "";
                this.ruleForm1.money = "";
                this.ruleForm1.time = "";
                this.ruleForm1.num = "";
                this.ruleForm1.deduction = "";
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "name",
          type: "input",
          value: this.ruleForm.name,
        });
      }
      if (this.ruleForm.status != "") {
        param.queryParams.push({
          name: "status",
          type: "select",
          values: [{ itemKey: this.ruleForm.status }],
        });
      }
      if (this.ruleForm.type != "") {
        param.queryParams.push({
          name: "member_type",
          type: "select",
          values: [{ itemKey: this.ruleForm.type }],
        });
      }
      this.$axios
        .post(`/admapi/violaterule/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    add() {
      this.title = "新增违规";
      this.dialogFormVisible = true;
      this.editId = "";
      this.ruleForm1.type = "";
      this.ruleForm1.type1 = "";
      this.ruleForm1.memo = "";
      this.ruleForm1.money = "";
      this.ruleForm1.time = "";
      this.ruleForm1.num = "";
      this.ruleForm1.deduction = "";
    },
    edit(val) {
      this.editId = val.id;
      this.title = "编辑违规";
      this.dialogFormVisible = true;
      this.getDetail();
    },
    getDetail() {
      this.$axios
        .post(`/admapi/violaterule/get/${this.editId}`)
        .then(({ data }) => {
          this.ruleForm1.type = JSON.stringify(data.memberType);
          this.ruleForm1.type1 = JSON.stringify(data.jobStatus);
          this.ruleForm1.time = JSON.stringify(data.putInAt);
          this.ruleForm1.deduction = JSON.stringify(data.withholdType);
          this.ruleForm1.money = data.withholdNum;
          this.ruleForm1.memo = data.memo;
          this.ruleForm1.num = data.putInNum;
        })
        .catch()
        .finally();
    },
    stop(val) {
      this.$confirm(val.status == 0 ? "是否启用" : "是否禁用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
            state: val.status == 0 ? 1 : 0,
          };
          this.$axios
            .post(`/admapi/violaterule/publish`, param)
            .then(({ data }) => {
              this.$message({
                message: val.status == 1 ? "下架成功" : "启用成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/violaterule/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
